import Registrar from "views/Registrar/Registrar";
import Historico from "views/Historico/Historico";
import Configuracao from "views/Configuracao/Configuracao";
import Justificativa from "views/Justificativa/Justificativa";
import LGPD from "views/LGPD/LGPD";

export const dashboardRoutes = [
  {
    path: "/registrar",
    name: "Registrar",
    icon: 'icon-touchpad-finger',
    component: Registrar
  },
  {
    path: "/historico",
    name: "Histórico",
    icon: 'icon-calendar-3',
    component: Historico
  },
  {
    path: "/justificativa",
    name: "Justificar Ausência",
    icon: 'icon-time-clock-file',
    component: Justificativa
  },
  {
    path: "/lgpd",
    name: "LGPD",
    icon: 'icon-common-file-text-check',
    component: LGPD
  },  
  {
    path: "/configuracao",
    name: "Configuração",
    icon: 'icon-cog',
    component: Configuracao
  },
  {
    path: "/#",
    name: "Logout",
    icon: 'icon-logout-2',
  },
];

export default dashboardRoutes;
